import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ExerciseContainer } from '../../agenda/agenda.component';
import { AcModel } from 'projects/runner/src/app/models/ac.model';
import { Subscription } from 'rxjs';
import { DataService } from 'projects/runner/src/app/services/data.service';

@Component({
  selector: 'app-agenda-block-exercise',
  templateUrl: './agenda-block-exercise.component.html',
  styleUrls: ['./agenda-block-exercise.component.scss']
})
export class AgendaBlockExerciseComponent implements OnInit, OnDestroy {

  @Input() container: ExerciseContainer = null;

  public ac: AcModel = null;
  public acSubscription: Subscription = null;

  constructor(
    private data: DataService
  ) { }

  ngOnInit(): void {
    this.acSubscription = this.data.ac$.subscribe({
      next: (ac: AcModel) => {
        if (ac !== null) {
          this.ac = ac;
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.acSubscription !== null) {
      this.acSubscription.unsubscribe();
    }
  }

}
